// keyboard filters for number inputs
//==============================

// allow only digits and editing keys in whole-number inputs
export const blockNonDigitKeys = (e) => {
    const allowed = ['Backspace', 'Delete', 'Tab', 'Enter', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End']
    if (e.ctrlKey || e.metaKey || allowed.includes(e.key) || /^[0-9]$/.test(e.key)) return
    e.preventDefault()
}
